/* eslint-disable no-plusplus */
/* eslint-disable no-useless-escape */

import { EPackageType, EPlaylistSourceType, IPackage, IPlaylistSource } from 'src/types';
import { OPTS } from '.';
import CONTANTS from './constants';
import { fetchMediaBlob, isProtectedMedia } from './media';

export default class FUNCS {
  static truncateString(input: string, size = CONTANTS.MAX_CHAR_SIZE_TABLE) {
    if (!input) return '';
    return input.length > size ? `${input.substring(0, size)}...` : input;
  }

  static makeid(length = 8) {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_';

    for (let i = 0; i < length; i += 1) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  static isValidURL(str = '') {
    const res = str.match(
      /(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
    );
    return res !== null;
  }

  static isValiCharactersFile(value: string) {
    const regex = /[\/#]/;
    const res = regex.test(value);

    return res;
  }

  static onKeyDownNumber(event: any) {
    const k = event.which;
    if ((k < 48 || k > 57) && (k < 96 || k > 105) && k !== 8 && k !== 190) {
      event.preventDefault();
      return false;
    }

    return true;
  }

  static removeDiacritics(str: string) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
    str = str.replace(/Đ/g, 'D');
    return str;
  }

  static getFullUrl(path?: string | null) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return `${base}${normalized}`;
  }

  static getFileExtension(path?: string | null) {
    if (!path) return '';
    const clean = path.split('?')[0].split('#')[0];
    const name = clean.split('/').pop() || '';
    const dot = name.lastIndexOf('.');
    if (dot <= 0) return '';
    return name.slice(dot + 1);
  }

  /**
   * File /uploads/... và /playlist/... chỉ nghe qua play_url (JWT).
   * Trả về chuỗi rỗng khi không có play_url để ẩn nút nghe thử.
   */
  static getPlaylistSourcePlayUrl(source: { url?: string | null; play_url?: string | null }) {
    const raw = source.url || '';
    const path = raw.split('?')[0];
    const isStoredFile =
      path.startsWith('/uploads/') ||
      path.startsWith('uploads/') ||
      path.startsWith('/playlist/') ||
      path.startsWith('playlist/');
    if (isStoredFile || !raw) {
      return source.play_url ? this.getFullUrl(source.play_url) : '';
    }
    return this.getFullUrl(raw);
  }

  static openExportedFile(filePath?: string | null) {
    if (!filePath) return;
    const url = this.getFullUrl(filePath);
    const link = document.createElement('a');
    link.href = url;
    const filename = filePath.split('?')[0].split('#')[0].split('/').filter(Boolean).pop();
    if (filename) link.setAttribute('download', decodeURIComponent(filename));
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  static download(data: any, filename: string, type: string) {
    const file = new Blob([data], { type });
    const a = document.createElement('a');
    const url = URL.createObjectURL(file);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }

  static getSearchParams(searchParams: URLSearchParams) {
    const result: any = {};
    searchParams.forEach((val, key) => {
      result[key] = val;
    });

    return result;
  }

  static convertToDuration(body: { day?: number; hour?: number; minute?: number; second?: number }) {
    return (body.day || 0) * 24 * 60 * 60 + (body.hour || 0) * 60 * 60 + (body.minute || 0) * 60 + (body.second || 0);
  }

  static convertDurationTime(duration = 0) {
    const seconds = Math.floor(duration % 60);
    const minutes = Math.floor((duration % 3600) / 60);
    const hours = Math.floor((duration % (3600 * 24)) / 3600);
    const days = Math.floor(duration / (3600 * 24));

    const s: string = seconds > 9 ? String(seconds) : `'0'${seconds}`;
    const m: string = minutes > 9 ? String(minutes) : `0${minutes}`;
    const h: string = hours > 9 ? String(hours) : `0${hours}`;
    const d: string = `${days}'d'`;

    const text = `${h}:${m}:${s}`;
    // if (hours > 0) {
    //   text = `${h}:` + text;
    // }

    return { seconds, minutes, hours, days, s, m, h, d, text };
  }

  static convertDuration(dur: number, isRound?: boolean) {
    let hour = 0;
    let minute = 0;
    let second = 0;

    // hour = Math.floor(dur / 3600);
    // minute = Math.floor((dur - hour * 3600) / 60);
    // second = Math.floor(dur - hour * 3600 - minute * 60);
    hour = isRound ? Math.round(dur / 3600) : Math.floor(dur / 3600);
    minute = isRound ? Math.round((dur - hour * 3600) / 60) : Math.floor((dur - hour * 3600) / 60);
    second = isRound ? Math.round(dur - hour * 3600 - minute * 60) : Math.floor(dur - hour * 3600 - minute * 60);
    const render = (time: number) => {
      return time < 10 ? `0${time}` : `${time}`;
    };

    return `${render(hour)}:${render(minute)}:${render(second)}`;
  }

  static createArrayFromNumber(end: number, start: number = 1) {
    const result = [];

    for (let i = start; i <= end; i++) {
      result.push(i);
    }

    return result;
  }

  static getDayOfMonth(month: number) {
    switch (month) {
      case 1:
      case 3:
      case 5:
      case 7:
      case 8:
      case 10:
      case 12:
        return 31;
      case 4:
      case 6:
      case 9:
      case 11:
        return 30;
      case 2:
        return 29;
      default:
        return 31;
    }
  }

  static convertPrice(n?: number | string, unit: string = 'đ') {
    if (!n) return `0`;

    const price = (Math.round(Number(n) * 10) / 10).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    if (unit === '') {
      return price;
    }
    return `${price} ${unit}`;
  }

  static convertTime(n?: number | string, unit: string = 's') {
    if (!n) return `0`;
    const price = (Math.round(Number(n) * 10) / 10).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return `${price} ${unit}`;
  }

  static getRandomColor() {
    return `#${Math.floor(Math.random() * 16777215).toString(16) || 'fce862'}`;
  }

  static convertAddress(input?: any, char = ', ') {
    let address = '';

    if (input?.province?.name) {
      address = input.province.name;
    }

    if (input?.commune?.name) {
      address = address + char + input.commune.name;
    }

    if (input?.village?.name) {
      address = address + char + input.village.name;
    }

    return address;
  }

  static onDownload = async (src: string, name?: string) => {
    const saveBlob = (blob: Blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = name || `dl_file_${Date.now()}`;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      link.remove();
    };

    try {
      if (isProtectedMedia(src)) {
        saveBlob(await fetchMediaBlob(src));
        return;
      }

      const response = await fetch(src);
      if (!response.ok) return;
      saveBlob(await response.blob());
    } catch (error) {
      console.log(error);
    }
  };

  /**
   * Quy định loại bản tin có giá trị (tạo sẵn):
   * 3: Bản tin âm thanh: nội dung phát, tệp tin, văn bản chuyển đổi
   * 5: Bản tin Trực tiếp: live micro
   * 6: Tiếp sóng: Link tiếp sóng
   */
  static renderPlaylistSource(sources: IPlaylistSource[]) {
    const result: string[] = [];
    sources.forEach((i) => {
      let type = '';
      if (
        i.type === EPlaylistSourceType.TEXT_TO_SPEECH ||
        i.type === EPlaylistSourceType.FILE ||
        i.type === EPlaylistSourceType.LIST
      ) {
        type = 'Bản tin âm thanh';
      }
      if (i.type === EPlaylistSourceType.URL) {
        type = 'Bản tin tiếp sóng';
      }
      if (i.type === EPlaylistSourceType.MICRO) {
        type = 'Bản tin trực tiếp';
      }
      if (!result.includes(type)) {
        result.push(type);
      }
    });

    return result.join(', ');
  }

  /**
   * Lấy mức độ ưu tiên của bản tin
   */
  static renderPlaylistPriority(priority: number) {
    const prio = OPTS.playlistPriorityOpts.find((i) => i.value === priority);

    return prio?.label || '';
  }

  /**
   * Lấy chế độ phát
   * mode = INSTANT: Khẩn cấp, phát ngay.
   * type = ONCE: Khung giờ cố định.
   * type = BY_DATE, BY_WEEK, BY_MONTH: Theo lịch phát đã thiết lập (theo ngày, theo tuần, theo tháng,…).
   */
  static renderPlaylistMode(mode: 'INSTANT' | 'SCHEDULED', type: 'ONCE' | 'BY_DATE' | 'BY_WEEK' | 'BY_MONTH') {
    if (mode === 'INSTANT') return 'Khẩn cấp, phát ngay';
    let result = '';
    switch (type) {
      case 'ONCE':
        result = 'Khung giờ cố định';
        break;
      case 'BY_DATE':
        result = 'Theo ngày';
        break;
      case 'BY_WEEK':
        result = 'Theo tuần';
        break;
      case 'BY_MONTH':
        result = 'Theo tháng';
        break;

      default:
        break;
    }
    return result;
  }

  static renderColorPriority(priority: number) {
    let result = '#1677ff';
    if (priority === 1) {
      result = '#faad14';
    }
    if (priority === 2) {
      result = '#ff4d4f';
    }
    return result;
  }

  static renderWeekday(dayOFWeek?: string) {
    if (!dayOFWeek) return '';
    const dayArr = dayOFWeek.split(',');

    const dayArrRender = dayArr
      .sort((a, b) => Number(a) - Number(b))
      .map((i) => {
        if (Number(i) === 0) return 'Chủ nhật';
        return `Thứ ${Number(i) + 1}`;
      });

    return dayArrRender.join(', ');
  }

  static renderMonthday(dayOFMonth?: string) {
    if (!dayOFMonth) return '';
    const dayArr = dayOFMonth.split(',');

    return dayArr.sort((a, b) => Number(a) - Number(b)).join(', ');
  }

  static isLatitude = (lat?: number | string) => {
    if (!this.isValidLocation(lat) || !lat) {
      return false;
    }
    const input = typeof lat === 'string' ? Number(lat) : lat;
    return Math.abs(input) <= 90;
  };

  static isLongitude = (lng?: number | string) => {
    if (!this.isValidLocation(lng) || !lng) {
      return false;
    }
    const input = typeof lng === 'string' ? parseFloat(lng) : lng;
    return Math.abs(input) <= 180;
  };

  static isValidLocation(str?: number | string) {
    return !Number.isNaN(Number(str));
  }

  static getPackageName(pack: IPackage) {
    let type = '';
    switch (pack.type) {
      case EPackageType.d:
        type = 'ngày';
        break;
      case EPackageType.m:
        type = 'tháng';
        break;
      case EPackageType.y:
        type = 'năm';
        break;
      case EPackageType.i:
        type = 'vĩnh viễn';
        break;

      default:
        break;
    }

    return `Gói ${pack.type === EPackageType.i ? 'vĩnh viễn' : `${pack.quantity} ${type}`}`;
  }
}
